import { useCookies } from 'react-cookie';

const TOUR_UPSELL_COOKIE = 'hasClosedTourUpsell';

export default function useTourUpsellCookie(listingAlias: string) {
  const [cookies, setCookies] = useCookies([TOUR_UPSELL_COOKIE]);
  const listings = cookies[TOUR_UPSELL_COOKIE] ?? [];
  const hasUpsellCookieSetForListing = listings.includes(listingAlias);

  const setUpsellCookie = () => {
    if (!hasUpsellCookieSetForListing) {
      const updatedListings = [...listings, listingAlias];
      setCookies(TOUR_UPSELL_COOKIE, updatedListings, { path: '/' });
    }
  };

  return { hasUpsellCookieSetForListing, setUpsellCookie };
}
